import { render, staticRenderFns } from "./my-upload.vue?vue&type=template&id=ff5c1020&scoped=true&"
import script from "./my-upload.vue?vue&type=script&lang=js&"
export * from "./my-upload.vue?vue&type=script&lang=js&"
import style0 from "./my-upload.vue?vue&type=style&index=0&id=ff5c1020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5c1020",
  null
  
)

export default component.exports